// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import ChangePasswordDialog from '../dialogs/ChangePasswordDialog';
import i18n from '../../i18n';
import { MenuItem } from '@mui/material';
import PasswordIcon from '@mui/icons-material/Password';
import config from '../../config';
import { getUserNameByRole } from '../../utils/cells';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class UsersPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'users';
        this.Server = this.props.context.getState().server.users;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['firstName', 'lastName'];

        const defaultHead = [
            {
                id: 'firstName', required: true,
                label: 'firstName',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'lastName', required: true,
                label: 'lastName',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'role', required: true,
                label: 'role',
                alignRight: false,
                cell: 'RoleSelect',
                show: 'name',
                from: 'roles',
                object: 'role',
                fullObject: true,
                // translate: 'enums',
                // needTranslate: (value) => value?.isDefault, // maybe used in future
                displayGrid: true,
                extraRender: (value, row) => getUserNameByRole(value, row)
                // enableCopyExtraRender: true,
            },
            {
                // The one gateway a gateway user sees. Required for that role and
                // refused for any other by the backend. The only binding a user
                // has: the merchant, provider and agent pickers that stood here
                // came from allpaypays and saved nothing — the backend has no
                // column for them.
                id: 'gatewayId',
                label: 'gateway',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                from: 'publicGateways',
                object: 'gateway',
                displayGrid: false,
                showIfDialog: (data) =>
                    data.role?.systemRole === config.roles.gateway.systemRole
            },
            {
                id: 'email', required: true, format: 'email',
                label: 'email',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'twoFactorEnabled',
                label: 'twoFactorAuth',
                alignRight: false,
                cell: 'Enable',
                type: 'boolean',
                role: 'admin_ecoo',
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            },
            {
                id: 'isActive',
                label: 'isActive',
                alignRight: false,
                cell: 'Checkbox',
                type: 'boolean',
                displayGrid: true
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head,
            changePassDialogOpen: false,
            activeUserId: null
        };
    }

    openChangePassDialog() {
        this.handleCloseMenu();
        this.setState({
            changePassDialogOpen: true,
            activeUserId: this.state.menuClickItemId
        });
    }

    renderCustomMenuItems() {
        return (
            <MenuItem onClick={() => this.openChangePassDialog()}>
                {/* 20px, as Edit and Delete draw theirs: at MUI's 24 the
                    label sat 4px right of theirs. */}
                <PasswordIcon sx={{ mr: 2, fontSize: 20 }} />
                {i18n.t('buttons.changePass')}
            </MenuItem>
        );
    }

    renderCustom() {
        // Says whose password it is: opened from a row, the dialog gave no sign.
        const user = this.rowById(this.state.activeUserId);
        const subject = user
            ? [
                  [user.firstName, user.lastName].filter(Boolean).join(' '),
                  user.email
              ]
                  .filter(Boolean)
                  .join(' · ')
            : '';
        return (
            <ChangePasswordDialog
                open={this.state.changePassDialogOpen}
                userId={this.state.activeUserId}
                subject={subject}
                onClose={() =>
                    this.setState({
                        changePassDialogOpen: false,
                        activeUserId: null
                    })
                }
            />
        );
    }
}
